var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-searchbar',{ref:_vm.id,attrs:{"expandable":"","custom-search":"","placeholder":"Buscar","backdrop":false},on:{"searchbar:search":_vm.buscar,"searchbar:disable":_vm.resetearBusqueda}})
}
var staticRenderFns = []

export { render, staticRenderFns }